import en from "./en-us";
import es from "./es-co";

export default {
  ...es,
  ...en,
};
